<wuc-list [lined]="true">
    <wuc-list-item>
        <wuc-link type="tertiary" [route]="'/' + appRoutesEnum.MyZone + '/' + myZoneRoutesEnum.MyInsurances">
            Mijn verzekeringen
        </wuc-link>
    </wuc-list-item>
    <wuc-list-item>
        <a class="link-flat no-underline" [href]="claimFunnelRoutesEnum.OldClaimFunnel" ins-authorize-before-redirect>
            Schademelden
        </a>
    </wuc-list-item>
    <wuc-list-item>
        <wuc-link type="tertiary" [route]="'/' + appRoutesEnum.MyZone + '/' + myZoneRoutesEnum.MyClaims">
            Schadestatus
        </wuc-link>
    </wuc-list-item>
    <wuc-list-item>
        <wuc-link type="tertiary" [route]="'/' + appRoutesEnum.MyZone + '/' + myZoneRoutesEnum.MyData">
            Mijn gegevens
        </wuc-link>
    </wuc-list-item>
    <wuc-list-item>
<!--        For invoices, the AngularJS variant is for InShared NL still used in production. Wait for project completion in collaboration with the BE financial team.-->
            <wuc-link
                type="tertiary"
                [route]="'/' + appRoutesEnum.MyZone + '/' + myZoneRoutesEnum.MyInvoices"
            >
                Facturen
            </wuc-link>
    </wuc-list-item>
    <wuc-list-item>
        <wuc-link type="tertiary" [route]="'/' + appRoutesEnum.MyZone + '/' + myZoneRoutesEnum.AnnualReward">
            JaarBalans
        </wuc-link>
    </wuc-list-item>
</wuc-list>
